import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ACTION_ROLES } from '../../constants/ActionRoles';

interface PermissionGateProps {
  actionRole: keyof typeof ACTION_ROLES;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

export const PermissionGate: React.FC<PermissionGateProps> = ({ actionRole, fallback = null, children }) => {
  const { hasRole } = useAuth();
  const hasAccess = ACTION_ROLES[actionRole].some(role => hasRole(role));
  return hasAccess ? <>{children}</> : <>{fallback}</>;
};

// Hook to check if current user has access for a specific action role
export const useHasActionRole = (actionRole: keyof typeof ACTION_ROLES): boolean => {
  const { hasRole } = useAuth();
  return React.useMemo(() => ACTION_ROLES[actionRole].some(role => hasRole(role)), [actionRole, hasRole]);
};
